import { OutlinedInput, styled } from "@mui/material";

export const CustomSmallOutlinedInput = styled(OutlinedInput)(() => ({
  '&.MuiOutlinedInput-root': {
    borderRadius: '8px',
    paddingRight: '8px',
    '& fieldset': {
      borderColor: '#054254',
    },
    '&:hover fieldset': {
      borderColor: '#054254',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#054254',
    },
  },
  fontSize: '14px',
  fontWeight: '600',
  color: '#054254',
  width: '90px',
  height: '36px',
  padding: '0px 12px',
}));

export const tableStyle = {
  "& thead tr:first-of-type": {
    "th:first-of-type": {
      paddingLeft: "20px",
    },
    "th > div > div > div": {
      whiteSpace: "nowrap",
    }
  },
  "& tbody tr td:first-of-type": {
    paddingLeft: "20px",
  },
  "& tbody tr:first-of-type td > p": {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
  height: "calc(100vh - 500px)",
  border: "1px solid #D9D9D9",
  borderRadius: "10px",
  minWidth: "100%",
  width: "100%",
  maxWidth: "100%",
  "@media (min-width: 600px)": {
    width: "100%",
  },
  "@media (min-width: 960px)": {
    width: "1100px",
  },
  "@media (min-width: 1280px)": {
    width: "1100px",
  },
  "@media (min-width: 1440px)": {
    width: "1100px",
  },
  "@media (min-width: 1680px)": {
    width: "1300px",
  },
  "@media (min-width: 2400px)": {
    width: "100%",
  },
}
